<template>
  <div class="flex flex-col w-full">
    <div class="mt-5">Filter :</div>
    <div class="flex flex-wrap pt-3">
      <vs-chip
        v-for="(item, index) in filter.list"
        :key="index"
        @click="removeFilter(index)"
        closable
      >
        <!-- <vs-avatar icon-pack="feather" icon="icon-send" /> -->
        <div>{{ item.type.label }}</div>
        <div class="p-1">:</div>
        <b>{{ item.query.label }}</b>
      </vs-chip>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      filter: (state) => state.globalApp.filter,
    }),
  },
  methods: {
    removeFilter(index) {
      this.$store.dispatch("globalApp/removeFilter", index);
    },
  },
};
</script>